import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from '@mui/material';
import { ModalConfirmationHook } from '@hooks/useConfirmationModal';
import React, { useEffect, useState } from 'react';
import Authorization from '@components/Utilities/Authorization';

interface ModalDialogProps {
    modalConfirmation: ModalConfirmationHook;
    needAuthorization?: boolean;
    onConfirmation: () => void;
}

export const ModalConfirmation: React.FunctionComponent<ModalDialogProps> = (props: any) => {
    const { modalConfirmation, needAuthorization, onConfirmation } = props;
    const [isAuthorized, setIsAuthorized] = useState<boolean>(!needAuthorization);

    const handleClose = () => {
        modalConfirmation.toggle();
    };

    const handleOnConfirmation = () => {
        handleClose();
        onConfirmation();
    };

    useEffect(() => {
        if (modalConfirmation.open) {
            setIsAuthorized(false);
        }
    }, [modalConfirmation.open]);

    return (
        <Dialog
            PaperProps={{
                style: { borderRadius: 15, padding: 4 }
            }}
            open={modalConfirmation.modalConfirmationData.open}
            onClose={handleClose}
            aria-labelledby="modal-confirmation-title"
            aria-describedby="modal-confirmation-description"
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle fontWeight={600}>{modalConfirmation.modalConfirmationData.title}</DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Typography variant="body1">{modalConfirmation.modalConfirmationData.description}</Typography>
                    {needAuthorization && <Divider />}
                    {needAuthorization && (
                        <Authorization
                            onAuthorized={() => setIsAuthorized(true)}
                            onUnauthorized={() => setIsAuthorized(false)}
                        />
                    )}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="error" onClick={handleClose}>
                    Cancel
                </Button>
                <Button disabled={!isAuthorized} variant="contained" onClick={handleOnConfirmation}>
                    Confirmation
                </Button>
            </DialogActions>
        </Dialog>
    );
};
